import TextList from 'common/components/TextList';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    urls: string[];
}

interface Props<T> {
    form: ObservableForm<T>;
    title?: string;
}

const UrlsField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    title,
}) => {
    title = title ? title : __('Add your website and/or social media pages');

    return (
        <Field
            form={form}
            name="urls"
            title={title}
            render={() => (
                <TextList
                    {...form.attach('urls')}
                    placeholder={__('E.g. www.best-website-ever.com')}
                    fill={true}
                />
            )}
        />
    );
};

export default UrlsField;
